import * as React from "react";
import { useVisibleOnce } from "./Visibility";
const VisibilityObserver = ({ children }) => {
    const [setNode, visibility] = useVisibleOnce({
        threshold: 0.0,
        rootMargin: "250px",
    });
    const ref = React.useCallback((node) => {
        setNode(() => node ?? null);
    }, [setNode]);
    return React.createElement("div", { ref: ref }, children(visibility));
};
export default VisibilityObserver;
//# sourceMappingURL=VisibilityObserver.js.map